module.exports = __webpack_public_path__ + "img/eth-logo.c1d8d4e0.svg";